<template>
  <j-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="12">
              <a-form-model-item :label="$t('文件名称')" prop="fileName">
                <a-input v-model="model.fileName" :placeholder="$t('请输入文件名称')" />
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('附件')" prop="fileUrl">
                <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange" :disabled="disableSubmit"/>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item :label="$t('文件描述')" prop="fileDescription">
                <a-textarea :placeholder="$t('请输入文件描述')" v-model="model.fileDescription" :rows="4" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>

<script>
  
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import JInput from '@/components/jeecg/JInput'
  import JUpload from '@/components/jeecg/JUpload'
  export default {
    name: 'FileManagementListModal',
    components: {
      DetailList,
      DetailListItem,
      JInput,
      JUpload
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          add: '/jeecg-system/user/userFile/add',
          edit: '/jeecg-system/user/userFile/edit',
          queryById:'/jeecg-system/user/userFile/queryById',
        },
        fileList: []
      }
    },
    computed: {
      // i18n：校验规则使用 computed 以响应语言切换
      validatorRules() {
        return {
          fileName:{ required: true,message: this.$t('请输入文件名称'), trigger: 'blur' },
          fileUrl:{ required: true,message: this.$t('请选择文件'), trigger: 'change' },
        }
      },
    },
    methods: {
      uploadChange(file){
        this.model.fileUrl = file;
        this.$refs.form.validateField('fileUrl');
      },
      init(row,type){
        if(type == 'add'){
          this.title = this.$t('新增');
          this.fileList = [];
          this.disableSubmit = false;
        }else if(type == 'edit'){
          this.title = this.$t('编辑');
          this.disableSubmit = false;
        }else{
          this.title = this.$t('详情');
          this.disableSubmit = true;
        }
        this.visible = true;
        this.model = Object.assign({},row);
        if(this.model.fileUrl) this.fileList = [this.model.fileUrl];
      },
      handleCancel() {
        this.visible = false;
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let url = '';
            if(this.model.id){
              url = this.url.edit;
            }else{
              url = this.url.add;
            }
            postAction(url, this.model).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
                that.visible = false;
                that.confirmLoading = false;
              } else {
                that.$message.warning(res.message);
              }
            })
            // .finally(() => {
            //   that.confirmLoading = false;
            // })
          }

        })
      },
    }
  }
</script>